import React, { useState, useEffect } from 'react';
import { CURRENT_TCAS_YEAR } from 'constants/school-year';
import cn from 'classnames';
import _ from 'lodash';
import { callAPI, getRoundState, userErrorMessage, showErrorToast, thaiMoment } from 'helpers';

// Components
import RoundContent from '../RoundContent';
import ModalOfferReplyConsent from './ModalRound41OfferReplyConsent';

// Hooks
import { useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';

// Data
import enabled from 'data/enabled'

const roundType = `41_${CURRENT_TCAS_YEAR}`;
const Round41 = ({ loading, loadFailed, offerCount, offers, replies, timestamp, expired }) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const query = useQuery();

  const [active, setActive] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  const { flow } = getRoundState({ roundType, timestamp, query });
  useEffect(() => {
    if (flow === 'default' && !_.get(profile, `consents_accepted_at.offer_reply_41_${CURRENT_TCAS_YEAR}`)) {
      setModalVisible(true);
    }
  }, [flow, profile]);

  const [accepting, setAccepting] = useState(false);
  const _onAcceptConsent = async (consentType) => {
    if (accepting) return;
    try {
      setAccepting(true);
      await callAPI({
        method: 'POST',
        url: '/applicants/me/consents',
        body: {
          consentType,
        },
      });
      setAccepting(false);
    } catch (error) {
      console.error(`Error while trying to accept consent: ${error.message}`);
      showErrorToast(userErrorMessage(error));
      setAccepting(false);
    }
    setModalVisible(false);
  };

  return (
    <div className={cn('t-collapse', { active })}>
      <h3 className='r-4-bar t-toggle' onClick={() => setActive(_active => !_active)}>
        {`ประกาศผลช่วงที่ 1: ${thaiMoment(enabled.round41.reply_start).add(543, 'years').format('D MMM YY')}`}
        <i className="i-toggle i-down-teal"></i>
      </h3>
      <RoundContent
        flow={flow}
        roundType={roundType}
        loading={loading}
        loadFailed={loadFailed}
        offerCount={offerCount}
        offers={offers}
        replies={replies}
        timestamp={timestamp} />
      <ModalOfferReplyConsent
        visible={offers.length && modalVisible && flow === 'default'}
        onSubmit={() => _onAcceptConsent(`offer_reply_41_${CURRENT_TCAS_YEAR}`)}
      />
    </div>
  )
}

export default Round41;